import { lazy, Suspense } from 'react';
import { SiteHeader } from '@/components/layout/SiteHeader';
import { SiteFooter } from '@/components/layout/SiteFooter';
import { Hero } from '@/components/landing/v2/Hero';
import { TrustBar } from '@/components/landing/v2/TrustBar';

// Below-fold sections are code-split. Each chunk only downloads
// when the user actually scrolls toward it, keeping the initial
// bundle small while the animated hero stays eager.
const WedgeSeam     = lazy(() => import('@/components/landing/v2/WedgeSeam').then((m) => ({ default: m.WedgeSeam })));
const PillarsBento  = lazy(() => import('@/components/landing/v2/PillarsBento').then((m) => ({ default: m.PillarsBento })));
const PayrollProof  = lazy(() => import('@/components/landing/v2/PayrollProof').then((m) => ({ default: m.PayrollProof })));
const AiCopilot     = lazy(() => import('@/components/landing/v2/AiCopilot').then((m) => ({ default: m.AiCopilot })));
const BorderBuddy   = lazy(() => import('@/components/landing/v2/BorderBuddy').then((m) => ({ default: m.BorderBuddy })));
const HowItWorks    = lazy(() => import('@/components/landing/v2/HowItWorks').then((m) => ({ default: m.HowItWorks })));
const Comparison    = lazy(() => import('@/components/landing/v2/Comparison').then((m) => ({ default: m.Comparison })));
const SecurityStrip = lazy(() => import('@/components/landing/v2/SecurityStrip').then((m) => ({ default: m.SecurityStrip })));
const PricingTeaser = lazy(() => import('@/components/landing/v2/PricingTeaser').then((m) => ({ default: m.PricingTeaser })));
const Faq           = lazy(() => import('@/components/landing/v2/Faq').then((m) => ({ default: m.Faq })));
const CtaSection    = lazy(() => import('@/components/landing/v2/CtaSection').then((m) => ({ default: m.CtaSection })));

const SectionFallback = () => <div style={{ minHeight: 400 }} />;

export function LandingPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <SiteHeader />

      <main className="flex-1">
        <Hero />
        <TrustBar />
        <Suspense fallback={<SectionFallback />}><WedgeSeam /></Suspense>
        <Suspense fallback={<SectionFallback />}><PillarsBento /></Suspense>
        <Suspense fallback={<SectionFallback />}><PayrollProof /></Suspense>
        <Suspense fallback={<SectionFallback />}><AiCopilot /></Suspense>
        <Suspense fallback={<SectionFallback />}><BorderBuddy /></Suspense>
        <Suspense fallback={<SectionFallback />}><HowItWorks /></Suspense>
        <Suspense fallback={<SectionFallback />}><Comparison /></Suspense>
        <Suspense fallback={<SectionFallback />}><SecurityStrip /></Suspense>
        <Suspense fallback={<SectionFallback />}><PricingTeaser /></Suspense>
        <Suspense fallback={<SectionFallback />}><Faq /></Suspense>
        <Suspense fallback={<SectionFallback />}><CtaSection /></Suspense>
      </main>

      <SiteFooter />
    </div>
  );
}
